import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";

import ListUnapprovedPromo from "../../components/unapproved-promo/List";

const List = () => {
    return (
        <Fragment>
            <div className="content-header">
                <h1>Unapproved Promo</h1>
                <div>
                    <Link to="/admin/unapproved-promo/approval">
                        <Button variant="contained">Accept/Reject</Button>
                    </Link>
                </div>
            </div>
            <ListUnapprovedPromo />
        </Fragment>
    );
};

export default List;
